import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'replace-media-modal-panel';

export default function ReplaceMediaModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.REPLACE_MEDIA_MODAL];
  });
  return (
    <Modal modalId={MODALS_IDS.REPLACE_MEDIA_MODAL} panelId={PANEL_ID} modalHeight="fit-content" modalWidth="100%">
      <LazyPanel
        panelDirectoryName="replace-media-panel"
        panelProps={{
          panelId: PANEL_ID,
          ...modalData.panelProps,
        }}
      />
    </Modal>
  );
}

interface OpenReplaceMediaModalOptions {
  isForAudio?: boolean;
  showAiImageOption?: boolean;
  showAiVideoOption?: boolean;
}

export const openReplaceMediaModal = ({...props}: OpenReplaceMediaModalOptions = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.REPLACE_MEDIA_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        ...props
      },
    })
  );
};
